import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserService } from '@core/auth/user/user.service';

@Injectable({
  providedIn: 'root',
})
export class LogGuard  {
  constructor(
    private _UserService: UserService,
    private _Router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this._UserService.loginData) {
      return this._Router.parseUrl(`/dashboard`);
    } else {
      return true;
    }
  }
}
